import { Button } from '@material-ui/core';
import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { PleaseWait } from '../../comps/PleaseWait';
import { IUser } from '../../main/entities';
import { OcEdit } from '../../main/OcEdit';
import { transl } from '../../main/transl';
import { mg } from '../../mg/mg';
import { toasterSvc } from '../../services/ToasterSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { adaptDataviewStoreColumn } from '../../stores/DataviewStoreColumn';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';
import { MgColumnExtras, mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';

const _state = DataviewStore.create({
	id: 'Profile',
	orgColumns: [
		'*email',
		'*firstname',
		'*surname',
		'street',
		'number',
		'town',
		'zipcode',
		'phone',
		'title',
		'wantsNewsEmail :bool',
		'wantsOrderOwnerEmail :bool',
		'wantsOrderInitiatorEmail :bool',
		'wantsOrderAttachment :bool',
	],
	sorting: {column: ''},
});

const columnist = mgColumnFactory.createColumnist([
		'*email',
		'*firstname',
		'*surname',
		'street',
		'number',
		'town',
		'zipcode',
		'phone',
		'title',
		'wantsNewsEmail :bool',
		'wantsOrderOwnerEmail :bool',
		'wantsOrderInitiatorEmail :bool',
		'wantsOrderAttachment :bool',
]);


const styles = createStyles({
	list: {
		display: 'flex',
		flexDirection: 'column',
	},
});

interface IProfileProps {
}

function extrasFn(entity: any) : Record<string, MgColumnExtras> {
	const editable = columnist.newEntity(entity) as Record<string, string>;

	return columnist.newExtras(entity, {
		title: {
			members: new Array({'id':'MR','text':transl('mr')}, {'id':'MRS',text:transl('mrs')}, {'id': 'DIVERS', 'text':transl('divers')})
		}
	})
}

@observer class _Profile extends OcScreen<IProfileProps & StyledComponentProps> {
	name() {
		return 'Profile';
	}

	submenu() {
		return [
		];
	}

	usedStores = () => ['User']

	@computed get _omnistore() {
		return getOmnistore();
	}

	@computed get _original() {
		return this._omnistore.profileStore.ownUser;
	}

	@observable _edited : IUser | undefined;

	reactions() {
		return [
			{
				when: () => this._original,
				then: () => {
					if (!this._edited && this._original) this._edited = {...this._original};
				},
				opts: {fireImmediately: true},
			},
		];
	}

	@action save = () => {
		if (!mg.assertPresent(this._edited)) return;
		this._omnistore.communicator.doPost('UpdateUser', this._edited)
			.then(toasterSvc.failure)
			.then(() => toasterSvc.success('saved'))
			.then(this._omnistore.entityManagerStore.get('User').fetchDirect);
	}

	renderBody() {
		if (!this._original) return <PleaseWait/>;
		const entity = this._edited;
		if (!entity) return <PleaseWait/>;
		const classes = this.props.classes || {};
		return <div>
			<div className={classes.list}>
				{
					_state.visibleColumns.map(c =>
						<OcEdit
							column={adaptDataviewStoreColumn(c)}
							entity={entity}
							reasonForReadonly={c.name === 'email'}
		          extras={extrasFn(c)}
							errorText={false}
							key={c.name}
						/>
					)
				}
			</div>
			<Button onClick={this.save}>{transl('save')}</Button>
		</div>;
	}
}

export const Profile = withStyles(styles)(_Profile);
